"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _ = _interopRequireDefault(require(".."));

/**
 * @file event.ts event事件处理
 * @author wangning25 <wangning25@baidu.com> on 2021/10/07.
 */

/**
 * na主动向webview通信的类型，下标为实际传输的数
 */
var onWebviewUpdateDataType = ['close', 'sync', 'im' // 2 是IM消息
];
/**
 * na主动向webview通信的唯一入口
 */

var handleWebviewUpdate = function handleWebviewUpdate(res) {
  /**
   * res数据结构：
   * {
   *   status: 0, // 0是调用成功，1是调用失败
   *   message: 'success', // 消息，可以为空
   *   data: {
   *     type:1 // 0 是关闭当前webview 1是刷新页面数据，2是IM消息
   *     payload:{} // 有传递的数据数据放在payload里
   *   }
   * }
   */
  var data = null;

  try {
    data = typeof res === 'string' ? JSON.parse(decodeURIComponent(res)) : res;
  } catch (error) {
    // TODO: 错误上报
    console.log(error);
  } // 基本的数据结构的校验


  if (data && (0, _typeof2.default)(data) === 'object' && data.data && (0, _typeof2.default)(data.data) === 'object') {
    var _context4;

    var eventType = onWebviewUpdateDataType[data.data.type]; // im消息事件

    if (eventType === 'im') {
      // 逐条message解析并派发事件
      if (data.data.payload instanceof Array) {
        var _context;

        (0, _forEach.default)(_context = data.data.payload).call(_context, function (message) {
          /**
           * message format example:
           * {"text": "{\"type\":107,\"data\":{\"service_type\":\"423\",\"service_info\":{\"num\":0,\"user_list\":null}}}"}
           * {"text": "{\"type\":107,\"data\":{\"service_type\":\"432\",\"service_info\":{\"activity_config\":{\"activity_info\":[]}}}}"}
           * {"text": "{\"type\":107,\"data\":{\"service_type\":\"10013\",\"service_info\":{\"content\":{\"content_type\":\"mix_room_rank_anchor\",\"rank\":\"10\",\"tips\":\"仅差1.6万热度即可超越前一名\"},\"mark_info\":[],\"msg_type\":\"13\",\"portrait\":\"\",\"room_id\":4.864983013e+09,\"user_id\":8.52517826e+08,\"user_name\":\"百度网友\"}}}"}
           * {"text": "{\"type\":107,\"data\":{\"service_type\":\"801\",\"service_info\":{\"assess_info\":{\"assess_count\":4,\"assess_list\":null,\"bg_assess_big_android\":\"https://ala-gift.cdn.bcebos.com/gift/2021-7/1625145001466/bg_assess_big.png\",\"bg_assess_big_ios\":\"https://ala-gift.cdn.bcebos.com/gift/2021-7/1625144743967/bg_assess_big_iOS.png\",\"bg_assess_small_android\":\"https://ala-gift.cdn.bcebos.com/gift/2021-7/1625145032996/bg_assess_small.png\",\"bg_assess_small_ios\":\"https://ala-gift.cdn.bcebos.com/gift/2021-7/1625144766671/bg_assess_small_iOS.png\",\"count_jump\":\"https://live.baidu.com/m/media/sdk/moodtest/half.html?room_id=4864983013\",\"has_assess\":1,\"user_jump\":\"https://live.baidu.com/m/media/sdk/moodtest/explain.html?room_id=4864983013\"},\"room_id\":4.864983013e+09}}}"}
           */
          try {
            var _context2;

            // 解析出该条IM消息的msgType、serviceType
            var text = typeof message.text === 'string' ? JSON.parse(decodeURIComponent(message.text)) : message.text;
            var msgType = text.type;
            var serviceType = text.data.service_type; // 派发im消息事件

            var eventNamesSet = new _set.default();
            eventNamesSet.add((0, _concat.default)(_context2 = "im:".concat(msgType, ":")).call(_context2, serviceType)); // im message小分类

            eventNamesSet.add("im:".concat(msgType, ":undefined")); // im message大分类（小分类会触发大分类）

            (0, _forEach.default)(eventNamesSet).call(eventNamesSet, function (eventName) {
              var _context3;

              if ((0, _includes.default)(_context3 = MyEE.eventNames()).call(_context3, eventName)) {
                MyEE.emit(eventName, {
                  status: data.status,
                  message: data.message,
                  data: [message]
                });
              }
            });
          } catch (error) {
            console.log('im message error: ', message, error);
          }
        });
      } // 其它事件，如：'sync'

    } else if ((0, _includes.default)(_context4 = MyEE.eventNames()).call(_context4, eventType)) {
      MyEE.emit(eventType, {
        status: data.status,
        message: data.message,
        data: data.data.payload
      });
    }
  }
};

var preOnWebviewUpdateCallback = window.__onWebviewUpdate__; // 防止覆盖当前页面内已注册的回调

window.addEventListener('__webviewUpdate__', handleWebviewUpdate);

window.__onWebviewUpdate__ = function (res) {
  handleWebviewUpdate(res);

  if ('function' === typeof preOnWebviewUpdateCallback) {
    preOnWebviewUpdateCallback(res);
  }

  return true;
};
/**
 * 根据自定义options生成eventName字符串
 * @param action 事件
 * @param event 事件参数
 * @returns
 */


var getEventNameString = function getEventNameString(action) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eventName = event; // im消息事件

  if (event.type === 'im') {
    var _context8, _context9;

    var enable = action === 'on' ? 1 : 0; // IM消息监听的端能力

    _.default.common.imSettings((0, _objectSpread2.default)({
      enable: enable
    }, event)).then(function (res) {
      var _context5, _context6, _context7;

      console.log((0, _concat.default)(_context5 = (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "imSettings enable:".concat(enable, " msgType:")).call(_context7, event.msgType, " serviceType:")).call(_context6, event.serviceType, " res:")).call(_context5, (0, _stringify.default)(res)));
    });

    eventName = (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = "".concat(event.type, ":")).call(_context9, event.msgType, ":")).call(_context8, event.serviceType); // 其它事件（支持的事件列表可以通过 bmls.onNames 查看），如：'sync'
  } else {
    eventName = event.type;
  }

  return eventName;
};

var MyEventEmitter = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(MyEventEmitter, _EventEmitter);

  var _super = (0, _createSuper2.default)(MyEventEmitter);

  function MyEventEmitter() {
    var _this;

    (0, _classCallCheck2.default)(this, MyEventEmitter);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "canOnNames", void 0);
    _this.canOnNames = onWebviewUpdateDataType;
    return _this;
  }

  (0, _createClass2.default)(MyEventEmitter, [{
    key: "on",
    value: function on(options, fn, context) {
      var eventName = getEventNameString('on', options);
      return (0, _get2.default)((0, _getPrototypeOf2.default)(MyEventEmitter.prototype), "on", this).call(this, eventName, fn, context);
    }
  }, {
    key: "off",
    value: function off(options, fn, context, once) {
      var eventName = getEventNameString('off', options);
      return (0, _get2.default)((0, _getPrototypeOf2.default)(MyEventEmitter.prototype), "off", this).call(this, eventName, fn, context, once);
    }
  }]);
  return MyEventEmitter;
}(_eventemitter.default);

var MyEE = new MyEventEmitter();
var _default = MyEE;
exports.default = _default;